import React from 'react';
import { Router } from 'react-router-dom';
import {createBrowserHistory} from 'history';

import Loading from '../components/elements/Loading';

import Content from './Content';
import { connect } from 'react-redux';
import AdmMenusAction from '../app/store/actions/admMenu';
import AuthAction from '../app/store/actions/auth';
import AuthRequests from '../app/server/auth';

export const history = createBrowserHistory();

class AppRouter extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {    
    const {
      menuRoutes,
    } = this.props;
    return (  
      <Router history={history}>
        <div className="page-wrapper">
          <Loading />
          <Content menuRoutes={menuRoutes}/>
        </div>
      </Router>
    )
  }
}

const mapStateToProps = state => ({ 
  menuRoutes: state.admMenus && state.admMenus.admMenuRoutes,
});

export default connect(mapStateToProps)(AppRouter);
